const fontFamily = {
	base: `"Minion-pro", helvetica, arial, sans-serif`,
	alt: `"Myriad-pro", helvetica, arial, sans-serif`
};

const fontWeight = {
	light: "400",
	medium: "500",
	regular: "600",
	semiBold: "600",
	bold: "700",
	black: "900",
};

const Typography = {
	fontFamily,
	fontWeight,
};

export default Typography;
